import {
    ApplicantEmploymentState,
    ApplicantHomeState,
    ApplicantPersonalState,
    CreditoRealUIState,
    BureauAskForNipViewState,
    BureauValidateNipViewState,
    CalculatorStepViewFieldErrorState,
    CalculatorStepViewState,
    CreditHistoryState,
    FilesState,
    HomeDataStepViewFieldErrorState,
    HomeDataStepViewState,
    HomeFileState,
    IdentificationFileState,
    InsuranceDataStepViewState,
    InsuranceSelectedState,
    InsuranceState,
    CreditoRealLoanApplicationState,
    NIPState,
    OtherFileState,
    PersonalDataStepViewFieldErrorState,
    PersonalDataStepViewState,
    ReferenceState,
    SummaryState,
    SummaryStepViewState,
    WorkDataStepViewErrorFieldState,
    WorkDataStepViewState,
    CalculatorState,
    WorkFileState,
} from '../types/mx/creditoReal/reducers';
import {EmploymentTypes} from '../types/mx/types';
import {Catalog} from '../../common/types/common';
import * as ValidateConstant from './ValidateConstant';
import {calculatorInit} from './CalculatorInit';
import {CreditoRealBankApplication} from '../types/mx/reducers';

export const creditoRealInit: CreditoRealBankApplication = {
    calculator: calculatorInit as CalculatorState,
    loanApplication: {
        currentStep: 0,
        highestStep: 0,
        applicantPersonal: {
            firstName: '',
            secondName: '',
            lastName: '',
            secondLastName: '',
            birthDate: '',
            docNumber: '',
            cellPhone: '',
            email: '',
            gender: {
                id: '',
                value: ''
            },
            civilStatus: {
                id: '',
                value: ''
            },
            studiesLevel: {
                id: '',
                value: ''
            },
            alreadyHasVehicle: {
                id: '',
                value: ''
            },
            nationality: {
                id: '',
                value: ''
            },
            economicDependents: ''
        } as ApplicantPersonalState,
        applicantHome: {
            address: '',
            extNumber: '',
            intNumber: '',
            postalCode: '',
            state: {
                id: '',
                value: ''
            },
            city: {
                id: '',
                value: ''
            },
            municipality: {
                id: '',
                value: ''
            },
            colonies: [],
            selectedColony: {
                id: '',
                value: ''
            },
            phone: '',
            houseHoldMeasure: {
                id: '',
                value: ''
            },
            houseHoldTime: {
                id: '',
                value: ''
            },
            houseType: {
                id: '',
                value: ''
            },
        } as ApplicantHomeState,
        applicantEmployment: {
            workplaceName: '',
            position: '',
            workingSince: '',
            address: '',
            extNumber: '',
            intNumber: '',
            postalCode: '',
            state: {
                id: '',
                value: ''
            },
            city: {
                id: '',
                value: ''
            },
            municipality: {
                id: '',
                value: ''
            },
            colonies: [],
            selectedColony: {
                id: '',
                value: ''
            },
            workplacePhone: '',
            workplacePhoneExt: '',
            includeMonthlyIncomes: true,
            monthlyIncomes: '',
            employmentRelationshipTypeId: '',
            documentType: {
                id: '',
                value: ''
            },
            businessType: {
                id: '',
                value: ''
            },
            billingTypeId: '',
            taxRegimeId: '',
            billingDocumentId: '',
        } as ApplicantEmploymentState,
        otherReferences: [] as ReferenceState[],
        acceptTerms: true,
        receiveNewsPromotions: false,
        nip: {
            identityBureau: '',
            skip: false
        } as NIPState,
        creditHistory: {
            bureauOption: [],
            bureauOptionCreditCardLastDigits: ''
        } as CreditHistoryState,
        insurance: {
            includeInsurance: true,
            insuranceSelected: {
                target: '',
                insuranceType: '',
                insuranceAmount: 0,
            } as InsuranceSelectedState,
            failInsurance: false,
        } as InsuranceState,
        marketingSource: {
            id: '',
            value: ''
        } as Catalog,
        token: '',
        createdAt: null,
        summary: {
            desiredVehicle: '',
            price: '',
            downPayment: '',
            term: '',
            amountFinance: '',
            detailCommission: '',
            monthlyPayment: '',
            monthlyInsurance: '',
        } as SummaryState,
        files: {
            identification: {
                ifeFrontFiles: [],
                ifeBackFiles: []
            } as IdentificationFileState,
            home: {
                homeFiles: []
            } as HomeFileState,
            work: {
                billingFiles: [],
            } as WorkFileState,
            other: {
                otherMonthFiles: [],
            } as OtherFileState
        } as FilesState
    } as CreditoRealLoanApplicationState,
    ui: {
        summaryStepView: {
            returnToSummary: false,
        } as SummaryStepViewState,
        personalDataStepView: {
            fieldErrors: {
                firstNameFieldError: ValidateConstant.ERROR_REQUIRED,
                secondNameFieldError: null,
                lastNameFieldError: ValidateConstant.ERROR_REQUIRED,
                secondLastNameFieldError: ValidateConstant.ERROR_REQUIRED,
                birthDateFieldError: ValidateConstant.ERROR_REQUIRED,
                docNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                cellPhoneFieldError: ValidateConstant.ERROR_REQUIRED,
                genderFieldError: ValidateConstant.ERROR_REQUIRED,
                civilStatusFieldError: ValidateConstant.ERROR_REQUIRED,
                studiesLevelFieldError: ValidateConstant.ERROR_REQUIRED,
                economicDependentsFieldError: ValidateConstant.ERROR_REQUIRED,
                alreadyHasVehicleFieldError: ValidateConstant.ERROR_REQUIRED,
                nationalityFieldError: ValidateConstant.ERROR_REQUIRED,
            } as PersonalDataStepViewFieldErrorState
        } as PersonalDataStepViewState,
        calculatorStepView: {
            fieldErrors: {
                yearFieldError: null,
                brandFieldError: ValidateConstant.ERROR_REQUIRED,
                modelFieldError: ValidateConstant.ERROR_REQUIRED,
                versionFieldError: ValidateConstant.ERROR_REQUIRED,
                provinceFieldError: null,
                postalCodeFieldError: ValidateConstant.ERROR_REQUIRED,
                assemblyCountryFieldError: ValidateConstant.ERROR_REQUIRED,
                priceFieldError: null,
                downPaymentFieldError: null,
                monthlyPaymentFieldError: null,
                postalCodeIsValid: false
            } as CalculatorStepViewFieldErrorState
        } as CalculatorStepViewState,
        bureauValidateNipView: {
            hasNipValidationError: false
        } as BureauValidateNipViewState,
        homeDataStepView: {
            hasPostalCodeError: false,
            fieldErrors: {
                addressFieldError: ValidateConstant.ERROR_REQUIRED,
                extNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                intNumberFieldError: null,
                postalCodeFieldError: ValidateConstant.ERROR_REQUIRED,
                stateFieldError: ValidateConstant.ERROR_REQUIRED,
                cityFieldError: null,
                municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED,
                phoneFieldError: ValidateConstant.ERROR_REQUIRED,
                houseHoldMeasureFieldError: ValidateConstant.ERROR_REQUIRED,
                houseHoldTimeFieldError: ValidateConstant.ERROR_REQUIRED,
                houseTypeFieldError: ValidateConstant.ERROR_REQUIRED,
            } as HomeDataStepViewFieldErrorState
        } as HomeDataStepViewState,
        bureauAskForNipView: {
            bureauAlreadyValidated: false,
            bureauAlreadyFailed: false
        } as BureauAskForNipViewState,
        workDataStepView: {
            hasPostalCodeError: false,
            fieldErrors: {
                workplaceNameFieldError: ValidateConstant.ERROR_REQUIRED,
                positionFieldError: ValidateConstant.ERROR_REQUIRED,
                workingSinceFieldError: ValidateConstant.ERROR_REQUIRED,
                addressFieldError: ValidateConstant.ERROR_REQUIRED,
                extNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                intNumberFieldError: null,
                postalCodeFieldError: ValidateConstant.ERROR_REQUIRED,
                stateFieldError: ValidateConstant.ERROR_REQUIRED,
                cityFieldError: ValidateConstant.ERROR_REQUIRED,
                municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED,
                workplacePhoneFieldError: ValidateConstant.ERROR_REQUIRED,
                monthlyIncomesFieldError: ValidateConstant.ERROR_REQUIRED,
                relationshipTypeIdFieldError: ValidateConstant.ERROR_REQUIRED,
                documentTypeFieldError: ValidateConstant.ERROR_REQUIRED,
                businessTypeFieldError: ValidateConstant.ERROR_REQUIRED,
                billingTypeFieldError: ValidateConstant.ERROR_REQUIRED,
                taxRegimeFieldError: null,
            } as WorkDataStepViewErrorFieldState
        } as WorkDataStepViewState,
        insuranceDataStepView: {
            hasInsuranceError: false,
            insuranceIncludesOptions: [{
                id: 'includeInsurance',
                value: true,
                label: 'Deseo incluir el seguro vehicular en el financiamiento'
            }, {
                id: 'excludeInsurance',
                value: false,
                label: 'Deseo pagar mi seguro vehicular de contado'
            }],
        } as InsuranceDataStepViewState
    } as CreditoRealUIState
};
